import { GuideApiService } from './GuideApiService';

export class IntegrationService {

  /**
   * Get an action on the server by the integration name.
   * /api/integrations/name/:integrationName`
   * @param {string} integrationName - The name of the integration to return.

   * @returns {Promise} - The promise that resolves to the response of the action.
   */
  static getIntegrationByName(integrationName) {
    return GuideApiService.makeRequest('GET', `/integrations/name/${integrationName}`);
  }
  
}

// Export the class
export default IntegrationService;
